<template>
  <b-row class="mt-4">
    <b-col></b-col>
    <b-col lg="3" class="text-right">
      <div class="valoracion-precio">
        <!-- SERVICIOS -->
        <div v-show="oferta.importeServicios > 0">
          <!-- <h4>Servicios</h4> -->
          <!-- Servicios -->
          <div class="bloque-valoracion">
            <h5>Total Servicios</h5>
            <div class="text-right">
              {{ importeServicios }}
              <span class="divisa-coloreada">
                {{ divisa.simbolo || divisa.abreviatura }}
              </span>
            </div>
          </div>

          <!-- Descuento servicios -->
          <div class="bloque-valoracion descuento" v-show="oferta.importeDescuentoServicios > 0">
            <h5>Descuento ({{ oferta.tipoDescuentoServicios }}%)</h5>
            <div class="text-right">
              {{ importeDescuentoServicios }}
              <span class="divisa-coloreada">
                {{ divisa.simbolo || divisa.abreviatura }}
              </span>
            </div>
          </div>

          <!-- Servicios con descuentos -->
          <div class="bloque-valoracion" v-show="oferta.importeDescuentoServicios > 0">
            <h5>Servicios con descuento</h5>
            <div class="text-right">
              {{ importeServiciosConDescuento }}
              <span class="divisa-coloreada">
                {{ divisa.simbolo || divisa.abreviatura }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "divisa"]),
    importeServicios() {
      return this.prepararImporte(this.oferta.importeServicios);
    },
    importeDescuentoServicios() {
      return this.prepararImporte(this.oferta.importeDescuentoServicios * -1);
    },
    importeServiciosConDescuento() {
      return this.prepararImporte(this.oferta.importeServicios - this.oferta.importeDescuentoServicios);
    },
  },
  methods: {
    prepararImporte(value) {
      const options = { maximumFractionDigits: 0, useGrouping: true };
      return Intl.NumberFormat("es-ES", options).format(Math.round(value));
    },
  },
};
</script>
